import { render, staticRenderFns } from "./OrdersManageFilter.vue?vue&type=template&id=950a48c0&"
import script from "./OrdersManageFilter.vue?vue&type=script&lang=js&"
export * from "./OrdersManageFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports